import React from 'react';
import PropTypes from 'prop-types';
import MedicalContentTreeItem, { useMedicalContentTreeItem } from '../_common/MedicalContentTreeItem';
import MedMainClassPane from './MedMainClassPane';

export default function MedMainClassTreeItem(props) {
  const {
    id,
    actionListId,
    label,
    setFormPane,
    onDeleteWarningMessage,
    onDeleteConfirmed,
    refreshParent,
    setTreeManagementServices,
  } = props;

  const {
    MCTreeItemLabel,
    updateLabel,
  } = useMedicalContentTreeItem(label);

  const onSelect = () => {
    setFormPane(
      <MedMainClassPane
        mainClassId={id}
        label={label}
        updateCallback={updateLabel}
        actionListId={actionListId}
      />,
    );
    setTreeManagementServices({
      onDeleteWarningMessage,
      deleteService: onDeleteConfirmed,
      onSuccess: refreshParent,
    });
  };

  return (
    <MedicalContentTreeItem
      id={id}
      MCTreeItemLabel={MCTreeItemLabel}
      isEndNode
      onSelect={onSelect}
    />
  );
}

MedMainClassTreeItem.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  setFormPane: PropTypes.func.isRequired,
  onDeleteWarningMessage: PropTypes.string.isRequired,
  onDeleteConfirmed: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
  actionListId: PropTypes.number.isRequired,
};
